import { render, staticRenderFns } from "./IncomeVerification.vue?vue&type=template&id=4c82834c"
import script from "./IncomeVerification.vue?vue&type=script&lang=js"
export * from "./IncomeVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports